import PlataformApi from "@/services/plataformApi"
import LoginUtils from '@/core/utils/login-utils'
import Router from "../router"

const Auth = {
  components: {
    PlataformApi
  },

  state: () => ({
    accessToken : LoginUtils.getToken(),
    errorsLogin : null,
    passwordLogin : null,
    emailLogin: null,
    errorsLoginSocial: null,
    createUserSocialLogin: null,
    cpfSocialCreateUser: null,
    telefoneSocialCreateUser:null,
    periodoSocialCreateUser:null,
    faculdadeIdSocialCreateUser:null,
    errorsSocialCreateUser: null
  }),

  getters: {
    accessToken: state => {
      return state.accessToken
    },
    errorsLogin: state => {
      return state.errorsLogin
    },
    emailLogin: state => {
      return state.emailLogin
    },
    passwordLogin: state => {
      return state.passwordLogin
    },
    errorsLoginSocial: state => {
      return state.errorsLoginSocial
    },
    createUserSocialLogin: state => {
      return state.createUserSocialLogin
    },
    cpfSocialCreateUser: state => {
      return state.cpfSocialCreateUser
    },
    telefoneSocialCreateUser: state => {
      return state.telefoneSocialCreateUser
    },
    periodoSocialCreateUser: state => {
      return state.periodoSocialCreateUser
    },
    faculdadeIdSocialCreateUser: state => {
      return state.faculdadeIdSocialCreateUser
    },
    errorsSocialCreateUser: state => {
      return state.errorsSocialCreateUser
    },
  },

  mutations: {
    setErrorsLogin (state, errorsLogin) {
      state.errorsLogin = errorsLogin
    },
    setAccessToken (state, accessToken) {
      LoginUtils.setToken(accessToken)
      state.accessToken = accessToken
    },
    setEmailLogin (state, emailLogin) {
      state.emailLogin = emailLogin
    },
    setPasswordLogin (state, passwordLogin) {
      state.passwordLogin = passwordLogin
    },
    setErrorsLoginSocial (state, errorsLoginSocial) {
      state.errorsLoginSocial = errorsLoginSocial
    },
    setCreateUserSocialLogin (state, createUserSocialLogin) {
      state.createUserSocialLogin = createUserSocialLogin
    },
    setCpfSocialCreateUser (state, cpfSocialCreateUser) {
      state.cpfSocialCreateUser = cpfSocialCreateUser
    },
    setTelefoneSocialCreateUser (state, telefoneSocialCreateUser) {
      state.telefoneSocialCreateUser = telefoneSocialCreateUser
    },
    setPeriodoSocialCreateUser (state, periodoSocialCreateUser) {
      state.periodoSocialCreateUser = periodoSocialCreateUser
    },
    setFaculdadeIdSocialCreateUser (state, faculdadeIdSocialCreateUser) {
      state.faculdadeIdSocialCreateUser = faculdadeIdSocialCreateUser
    },
    setErrorsSocialCreateUser (state, errorsSocialCreateUser) {
      state.errorsSocialCreateUser = errorsSocialCreateUser
    },
  },

  actions: {
    async logout(){
      await PlataformApi.logout()
      LoginUtils.logout()
    },
    async login({ commit, dispatch, getters} ){
      commit('setErrorsLogin', null)

      try {
        let response = await PlataformApi.login({
          grant_type : 'password',
          client_id : process.env.VUE_APP_CLIENT_ID,
          client_secret : process.env.VUE_APP_CLIENT_SECRET,
          username : getters.emailLogin,
          password : getters.passwordLogin,
          scope : ''
        })

        commit('setAccessToken', response.access_token)

        await dispatch('getUser')

        Router.currentRoute.query.redir ? Router.push(Router.currentRoute.query.redir): Router.push("/")
      } catch (errors) {
        if (errors?.response?.status && errors.response.status == 401){
          commit('setErrorsLogin', { auth : 'Email ou senha inválido'})
        } else {
          commit('setErrorsLogin', { auth : 'Sistema fora do ar'})
        }
      }
    },
    async loginSocialGoogle ({ dispatch }, { access_token }) {
      await dispatch('loginSocialGeneric', {provider : 'google', access_token})
    },
    async loginSocialFacebook ({ dispatch }, { access_token }) {
      await dispatch('loginSocialGeneric', {provider : 'facebook', access_token})
    },
    async loginSocialGeneric({ commit, dispatch} , request){
      commit('setErrorsLoginSocial', null)
      commit('setCreateUserSocialLogin', null)

      try {
        let response = await PlataformApi.socialLogin(request)

        if(response.access_token){
          commit('setAccessToken', response.access_token)

          await dispatch('getUser')
          Router.currentRoute.query.redir ? Router.push(Router.currentRoute.query.redir): Router.push("/")
        }else{
          response.provider = request.provider
          commit('setCreateUserSocialLogin', response)
        }

      } catch (errors) {
        commit('setErrorsLoginSocial', 'Falha na autentição pelo ' + request.provider)
      }
    },
    async createSocialUser({ commit, dispatch, getters}){
      commit('setErrorsSocialCreateUser', null)

      try {
        let response = await PlataformApi.createSocialUser({
          name: getters.createUserSocialLogin.social_user_details.name,
          email: getters.createUserSocialLogin.social_user_details.email,
          cpf: getters.cpfSocialCreateUser,
          termos_de_uso: 1,
          telefone: getters.telefoneSocialCreateUser,
          faculdade_id: getters.faculdadeIdSocialCreateUser,
          periodo: getters.periodoSocialCreateUser,
          access_token: getters.createUserSocialLogin.social_user_details.token, 
          provider: getters.createUserSocialLogin.provider
        })
        
        if(response.access_token){
          commit('setAccessToken', response.access_token)

          await dispatch('getUser')
          commit('setCreateUserSocialLogin', null)
          commit('setErrorsSocialCreateUser', null)
          Router.currentRoute.query.redir ? Router.push(Router.currentRoute.query.redir): Router.push("/")
        }else{
          if(response.cpf){
            commit('setErrorsSocialCreateUser', {validations: response} )
          }
        }

      } catch (errors) {
        commit('setErrorsSocialCreateUser', {api: errors.response})
      }
    },
  }
};

export default Auth;